<div id="tituloPaginaPagamentos" class="app-titulo-pagina visible-xs">
    <span>Pagamentos</span>
</div>

<div class="col-xs-12 app-banner" style="margin-top: 25px;">
    <img class="hidden-xs" src="assets/img/banners/pagamento.png" alt="Banner">
    <img class="visible-xs" src="../../assets/img/banners/mobile_pagamento.png" alt="Banner Pagamento">
</div>

<div *ngIf="processando" class="text-center">
    <i class="fa fa-spinner fa-pulse fa-4x"></i>
</div>

<input id="length-tabela-pagamento" type="hidden" value="{{mainService.pagamentoService.pagamentos?.length}}">

<div *ngIf="!processando">

    <a id="novo-pagamento-individual" (click)="mainService.loginService.changeRoute('/pagamentos/individual')"
        class="btn app-btn-best-v2" style="margin-bottom: .5rem;">
        <i class="fa fa-plus-circle"></i> Novo Pagamento
    </a>

    <!-- Tela de pagamento individual antiga desabilitada. Excluir novo-pagamento e confirmação-novo-pagamento -->
    <!-- <a id="novo-pagamento" (click)="mainService.loginService.changeRoute('/pagamentos/novo')"
        class="btn app-btn-best-v2" style="margin-bottom: .5rem;">
        <i class="fa fa-plus-circle"></i> Novo Pagamento
    </a> -->

    <a id="novo-pagamento" (click)="mainService.loginService.changeRoute('/pagamentos/lote')"
        class="btn app-btn-best-v2" style="margin-bottom: .5rem;">
        <i class="fa fa-plus-circle"></i> Pagamentos em lote
    </a>

    <div class="table-responsive">
        <table
            *ngIf="mainService.pagamentoService.pagamentos !== undefined && mainService.pagamentoService.pagamentos.length > 0"
            class="table table-striped table-hover">
            <thead>
                <tr>
                    <th>Código</th>
                    <th><span class="glyphicon glyphicon-arrow-down"></span>Data</th>
                    <th>Linha Digitável</th>
                    <th>CPF/CNPJ do beneficiário</th>
                    <th>Pontos</th>
                    <th>Status</th>
                    <th>Descrição</th>
                </tr>
            </thead>
            <tbody id="tabelaPagamentoBody">
                <tr *ngFor="let pagamento of mainService.pagamentoService.pagamentos">
                    <td>{{ pagamento.id }}</td>
                    <td>{{ pagamento.solicitacao| dateFormat:'dd/MM/yyyy HH:mm' }}</td>
                    <td>{{ pagamento.linhaDigitavel| pagamento:pagamento.tipo }}</td>
                    <td>{{ pagamento.beneficiarioDocumento }}</td>
                    <td>{{ pagamento.valorPontos }}</td>
                    <td>{{ pagamento.status }}</td>
                    <td>{{ pagamento.observacao }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/pagamento/pagamento.component.html